/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const createCampaignDataStatusSchema = z.enum(['draft', 'review', 'publishing', 'active', 'completed'])

export type CreateCampaignDataStatusSchema = z.infer<typeof createCampaignDataStatusSchema>
